// extracted by mini-css-extract-plugin
export default {"textEllipsis":"styles_textEllipsis__ODRQM"};